// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import Joi from 'joi'

import { EntityConstants } from 'constants/index'
import { phoneNumberSchema } from 'helpers/phoneValidation.helpers'

const messages = {
  'string.base': 'Field must be a string',
  'string.email': 'Invalid email format',
  'string.max': `Field must be at most {#limit} characters`,
}

function validationSchema() {
  return Joi.object({
    firstName: Joi.string()
      .trim()
      .required()
      .max(EntityConstants.MAX_FIRST_NAME_LENGTH)
      .messages(messages)
      .label('First Name'),
    lastName: Joi.string()
      .trim()
      .required()
      .max(EntityConstants.MAX_FIRST_NAME_LENGTH)
      .messages(messages)
      .label('Last Name'),
    email: Joi.string()
      .trim()
      .email({ tlds: { allow: false } })
      .required()
      .max(EntityConstants.MAX_ADDRESS_LENGTH)
      .messages(messages)
      .label('Email'),
    telephoneNumber: phoneNumberSchema,
    isActive: Joi.boolean().allow(null, '').optional(),
    role: Joi.string().trim().optional(),
  })
}

export default validationSchema
